
import { Modal } from 'react-bootstrap'

export default function ConfirmModal({ show, onClose, company, onSubmitApproval, isDefault = false }) {

    const acceptCompany = () => {
        onSubmitApproval(company, true)
        onClose();
    };

    const rejectCompany = () => {
        onSubmitApproval(company, false)
        // optional callback so parent can handle reject logic / API
        onClose();
    };

    return (
        <Modal
            show={show}
            onHide={onClose}
            className="moddal-width companyEdit-modal ps-0 add-modal"
        >
            <div className="modal-header pt-2">
                <button
                    type="button"
                    className="btn-close text-dark close-button"
                    onClick={onClose}
                >
                    &nbsp;
                </button>
            </div>
            <div className="modal-body pb-0">
                <div className="row">
                    <div className="col-12 text-center mb-3">
                        <h5 className="mb-2">Review {isDefault ? 'advisor account' : 'business account'} request</h5>
                        <p className="mb-0">
                            Please review <strong>{company?.companyName}</strong> and choose an action.<br />
                            You can <strong>approve</strong> the {isDefault ? 'advisor account' : 'business account'} to grant full dashboard access.
                            {/* or <strong>reject</strong> the request if it does not meet your requirements. */}
                        </p>
                    </div>
                    <div className="row">
                        <div className="col-md-3"></div>
                        <div className="col-md-3 cancelbox">
                            <button
                                type="button"
                                onClick={onClose}
                                className="btn save-btn confirm m-0"
                            >
                                close
                            </button>
                        </div>
                        <div className="col-md-3">

                            <button
                                className="btn save-btn cancel m-0"
                                onClick={acceptCompany}
                                type="button"
                            >
                                Confirm
                            </button>
                        </div>
                        <div className="col-md-3"></div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}
